module.exports = __webpack_public_path__ + "src/assets/img/usb_03.4ceb5c51.png";